<footer class="footer-container scrollbar-hide">
    <div class="top-section">
        <div class="footer-main-content">
            <img class="logo" src="/assets/images/shared/brand-logo-white.png" alt="logo" [draggable]="false" />
            <div class="company-name">UMW EQUIPMENT & ENGINEERING PTE LTD</div>
            <div class="company-address">{{ COMPANY_ADDRESS }}</div>
            <div class="company-contact mt-4">
                <span translate class="w-8">Tel</span>
                <span> : </span>
                <span>{{ COMPANY_PHONE }}</span>
            </div>
            <div class="company-contact">
                <span translate class="w-8">Fax</span>
                <span> : </span>
                <span>{{ COMPANY_FAX }}</span>
            </div>
            <div class="company-social-media-links-container">
                @for (item of companySocialMediaList; track $index) {
                    <a target="_blank" [href]="item.link">
                        <img [alt]="item.alt" [src]="item.image" [draggable]="false" />
                    </a>
                }
            </div>
            <img
                class="background-image"
                src="/assets/images/footer/footer-background.png"
                alt="footer-background"
                [draggable]="false" />
        </div>
        <div class="footer-navigation-panel">
            <div class="navigation-list">
                <a translate class="title" [routerLink]="['/products']">Products</a>
                <div class="link-list">
                    @for (category of PRODUCT_CATEGORIES; track $index) {
                        <a
                            class="link"
                            [ngClass]="{ hidden: !checkIfCategoryExist(category.filter) }"
                            [routerLink]="['/products']"
                            [queryParams]="{ categories: category.filter, applyOnMobile: true }">
                            {{ category.label }}
                        </a>
                    }
                </div>
            </div>
            <div class="navigation-list">
                <a translate class="title" [routerLink]="['/about-us']">About Us</a>
                <div class="link-list">
                    <a translate class="link" [routerLink]="['/about-us']" [queryParams]="{ section: 'about-us' }">
                        Our Story
                    </a>
                    <a translate class="link" [routerLink]="['/about-us']" [queryParams]="{ section: 'how-to-rent' }">
                        How To Rent
                    </a>
                </div>
            </div>
            <div class="navigation-list">
                <a translate class="title" [routerLink]="['/blogs']">Blogs</a>
                <div class="link-list">
                    <a translate class="link" [routerLink]="['/blogs']">Our Blogs</a>
                </div>
            </div>
            <div class="navigation-list">
                <div translate class="title">Quick Access</div>
                <div class="link-list">
                    <a translate class="link" [routerLink]="['/faq']">FAQs</a>
                    <a translate class="link" [routerLink]="['/data-protection-notice']">Data Protection Notice</a>
                    <a translate class="link" [routerLink]="['/rental-agreement']">Rental Agreement</a>
                    <button type="button" translate class="link text-left" (click)="onRentalGuideBookClick()">
                        Rental Guide Book
                    </button>
                    <a translate class="link" [routerLink]="['/contact-us']">Contact Us</a>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-section">
        <div class="terms">
            <a translate [routerLink]="['/terms-of-use']">Terms of Use</a>
            <a translate [routerLink]="['/privacy-policy']">Privacy Policy</a>
        </div>
        <div class="copyright">
            Copyright © {{ currentYear }} Sime Darby Forklift Rental Registration No. 200601032645 (752404-U). All
            Rights Reserved.
        </div>
    </div>
</footer>
